import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { AssignCheckbookState } from '../reducers/assign-checkbook.reducer';
import * as selectors from '../selectors/assign-checkbook.selectors';

@Injectable()
export class AssignCheckbookFacadeService extends FacadeService {
  constructor(public override store: Store<AssignCheckbookState>) {
    super(store);
  }

  // OBSERVABLES

  displayedColumns$ = this.storeSelect(selectors.getDisplayedColumns);
  displayedColumnKeys$ = this.storeSelect(selectors.getDisplayedColumnKeys);
  membersData$ = this.storeSelect(selectors.getMembersData);
  search$ = this.storeSelect(selectors.getSearch);
  validUntilDate$ = this.storeSelect(selectors.getValidUntilDate);
  validUntilDateFormat$ = this.storeSelect(selectors.getValidUntilDateFormat);
  showTable$ = this.storeSelect(selectors.getShowTable);
  schema$ = this.storeSelect(selectors.getSchema);
  loyaltyMemberId$ = this.storeSelect(selectors.getLoyaltyMemberId);
  showValidUntilDateErrorMsg$ = this.storeSelect(selectors.getShowCheckbookNumberErrorMsg);
  assignCheckbookDataAreValid$ = this.storeSelect(selectors.getAssignCheckbookDataAreValid);

  // OBSERVABLE'S VALUES

  get search() {
    return this.storeSnapshot(this.search$);
  }

  get validUntilDate() {
    return this.storeSnapshot(this.validUntilDate$);
  }

  get validUntilDateFormat() {
    return this.storeSnapshot(this.validUntilDateFormat$);
  }

  get membersData() {
    return this.storeSnapshot(this.membersData$);
  }

  get showTable() {
    return this.storeSnapshot(this.showTable$);
  }

  get schema() {
    return this.storeSnapshot(this.schema$);
  }

  get loyaltyMemberId() {
    return this.storeSnapshot(this.loyaltyMemberId$);
  }

  get showValidUntilDateErrorMsg() {
    return this.storeSnapshot(this.showValidUntilDateErrorMsg$);
  }

  get assignCheckbookDataAreValid() {
    return this.storeSnapshot(this.assignCheckbookDataAreValid$);
  }
}
